import React, { Component } from 'react';
import { FormControl, Input, InputAdornment, InputLabel, TextField } from '@mui/material';
import MyTooltip from '../../common/tooltip';
import SelectorCopy from '../../common/selectorCopy';
import CSVExport from '../../common/csvExport';

import './style.scss';
import { withNavigate } from '../../utility';
import moment from 'moment';

class expanableComponentIpAccess extends Component {
    constructor(props) {
        super(props);
        this.state = {
            headersCSV: [],
            dataCSV: []
        };
    }

    componentDidMount() {
        this.popolaCSV();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.data !== this.props.data) {
            this.popolaCSV();
        }
    }

    popolaCSV = () => {
        const headersTemp = [
            { label: "Device ID", key: "deviceId" },
            { label: "Accesso", key: "dateAccess" },
            { label: "User Agent", key: "userAgent" }
        ];

        const dataTemp = this.props.data?.details?.map((item) => ({
            deviceId: item.deviceId || '',
            dateAccess: this.formatData(item.ts),
            userAgent: item.ua || ''
        })) ?? [];

        this.setState({
            headersCSV: headersTemp,
            dataCSV: dataTemp
        });
    }

    goToPage = (deviceId) => {
        this.props.setIdPlayerForDetail(deviceId);
        this.props.handleNavigation(this.props.navigate, `/player/devices`);
    }

    formatData = (data) => {
        if (!data) return '';
        return moment(data).format('LL') + ' - ' + moment(data).format('LTS');
    }

    render() {
        const { data } = this.props;

        return (
            <div className="tabExpanablePlayer">
                <div className="col-12 text-center">
                    <CSVExport
                        data={this.state.dataCSV}
                        headers={this.state.headersCSV}
                        filename={`loginInfo-${data.deviceIp}.csv`}
                    />
                </div>

                {
                    data?.details?.map((el, key) => (
                        <div className="row" key={key} style={{ marginBottom: '2rem' }}>

                            <div className="col-sm-6 col-12">
                                <FormControl className='customSelect'>
                                    <InputLabel htmlFor={`id-device-${key}`}>
                                        ID Device
                                    </InputLabel>

                                    <Input
                                        id={`id-device-${key}`}
                                        value={el.deviceId || ''}
                                        readOnly
                                        endAdornment={
                                            el.deviceId && (
                                                <InputAdornment position="end">
                                                    <SelectorCopy
                                                        item={el.deviceId}
                                                        infoNotify={this.props.infoNotify}
                                                        noLabel
                                                    />
                                                    <span
                                                        className="clickForPlayer"
                                                        onClick={() => this.goToPage(el.deviceId)}
                                                    >
                                                        <MyTooltip
                                                            title="Vai a questo ID"
                                                            position="top"
                                                            content={<i className="fas fa-share-square"></i>}
                                                        />
                                                    </span>
                                                </InputAdornment>
                                            )
                                        }
                                    />
                                </FormControl>
                            </div>

                            <div className="col-sm-6 col-12">
                                <TextField
                                    value={this.formatData(el.ts)}
                                    label="Data"
                                    variant="standard"
                                    fullWidth
                                />
                            </div>

                            <div className="col-sm-12 col-12">
                                <TextField
                                    value={el.ua || ''}
                                    label="User Agent"
                                    variant="standard"
                                    fullWidth
                                />
                            </div>
                        </div>
                    ))
                }
            </div>
        );
    }
}

export default withNavigate(expanableComponentIpAccess);